<template>
  <section v-if="getSelectedItems.length" class="catalog-filter-selected">
    <div class="filter-selected-items">
      <span
        v-for="item in getSelectedItems"
        :key="item.CONTROL_ID"
        class="filter-selected-item"
        @click="$emit('remove', item)"
      >
        <span v-if="item.COLOR" class="selected-color-border">
          <span
            :style="`background-color: ${item.COLOR}`"
            class="selected-color-border__body"
          ></span>
        </span>
        {{ item.printRange || item.VALUE }}
        <DefButtonCross />
      </span>
    </div>

    <CatalogSaveFilter :messages="messages" @saveFilter="handlerSaveFilter" />

    <button type="reset" form="filter" class="selected-clean-clean" @click="$emit('resetFilter')">
      <svg class="selected-clean-clean__icon"><use xlink:href="#svg-trash"></use></svg>
      {{ messages.cleanAll }}
    </button>
  </section>
</template>

<script>
import CatalogSaveFilter from '@components/Catalog/CatalogFilter/CatalogSaveFilter.vue';
import CatalogSaveFilterModal from '@components/Catalog/CatalogFilter/CatalogSaveFilterModal.vue';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';
import { mapActions, mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';

export default {
  name: 'CatalogFilterSelected',
  components: { DefButtonCross, CatalogSaveFilter },
  props: ['result', 'selectedItems'],
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    getSelectedItems() {
      if (this.selectedItems) return this.selectedItems;

      const items = this.result.ITEMS;
      const arr = [];
      if (items) {
        for (const key in items) {
          const subObj = items[key].VALUES;

          if (items[key].DISPLAY_TYPE === 'A') {
            /** get string for price range* */
            const range = {};
            const newObj = {
              ...items[key],
              CODE: items[key].CODE,
            };
            for (const i in subObj) {
              if (subObj[i].HTML_VALUE) {
                range[i] = subObj[i].HTML_VALUE;
              }
            }

            if (range && range.MIN && range.MAX) {
              newObj.printRange = `от ${range.MIN} до ${range.MAX}`;
            } else if (range.MIN) {
              newObj.printRange = `от ${range.MIN}`;
            } else if (range.MAX) {
              newObj.printRange = `до ${range.MAX}`;
            }
            if (newObj.printRange) {
              arr.push(newObj);
            }

            // range prices checkbox
            if (items[key]?.priceRange?.VALUES?.length) {
              items[key]?.priceRange?.VALUES.forEach((item) => {
                if (item.CHECKED) {
                  arr.push({ ...item, priceRange: true });
                }
              });
            }
          } else if (items[key].VALUES) {
            /** get all checkbox * */
            for (const i in subObj) {
              if (subObj[i].CHECKED) {
                arr.push({
                  ...subObj[i],
                  CODE: items[key].CODE,
                });
              }
            }
          }
        }
      }

      return arr;
    },
    messages() {
      return this.result.messages;
    },
    ...mapState({
      isAuthorized: ({ personal }) => personal?.data?.authInfo?.isAuthorized,
    }),
  },
  methods: {
    ...mapActions({
      addUserCatalogFilter: 'catalog/addUserCatalogFilter',
    }),
    handlerSaveFilter() {
      if (this.isAuthorized) {
        this.modal.show(CatalogSaveFilterModal, {}, { width: '500px', backgroundClose: false });
      } else {
        this.modal.show(SignIn, {}, { width: '900px', backgroundClose: false });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-filter-selected {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 12px;
}
.filter-selected-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-selected-item {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #cacece;
  font-weight: 500;
  font-size: rem(14);
  line-height: 125%;
  border-radius: 100px;
  cursor: pointer;
  :deep(.def-button-cross__icon) {
    fill: var(--color-red);
    margin-left: 8px;
  }
}
.selected-color-border {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e6e8eb;
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: 8px;
  &__body {
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    flex-shrink: 0;
  }
}
.selected-clean-clean {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--color-red);
  &__icon {
    fill: currentColor;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>
